import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'transformDate',
    standalone: false
})
export class TransformDatePipe implements PipeTransform {

  transform(value: any, arg?: string): any {

    // supports integers as value and converts them to strings in a two digits format
    if (arg === '00' && typeof value === 'number') {
      if (value >= 10) {
        return value;
      }
      return '0' + value.toString();
    }

    // converts to moment format
    if (!value) {
      return value;
    }
    if (!arg) {
      return moment(value).toDate();
    }

    return moment(value).format(arg);
  }

}
